import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { PageInfo } from '../components/page-info'
import { Heading } from '../components/heading'
import { Button } from '../components/button'
import { ProductsSelection } from './output-feed/ProductsSelection'
import { FieldSetup } from './output-feed/FieldSetup'
import { FeedHosting } from './output-feed/FeedHosting'
import { ErrorNotification, SuccessNotification } from '../components/notification';
import { Loader } from '../components/loader'
import { Fragment } from 'react/jsx-runtime'
import { ChevronDownIcon, FunnelIcon, ArrowsRightLeftIcon, DocumentTextIcon, PencilSquareIcon, ArrowRightIcon, ArrowLeftIcon, DocumentPlusIcon } from '@heroicons/react/20/solid';
import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Cookies from 'js-cookie';
import config from '../config.js'
function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
let cacheFTPProtocol = "";
let cacheFTPHostname = "";
let cacheFTPPort = "";
let cacheFTPUsername = "";
let cacheFTPPassword = "";
export default function EditOutputFeed() {
    const page_info = `The process of creating a new output feed is quick and simple - just follow the wizard below and we'll do the rest.`;

    const sumo_current_account = Cookies.get('sumo_current_account');
    const [feedTags, setFeedTags] = useState([]);
    const [productFields, setProductFields] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [errors, setErrors] = useState({});
    const [showFieldsMap, setShowFieldsMap] = useState({});
    const [errorMsg, setErrorMsg] = useState('');
    const [showErrorBox, setShowErrorBox] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');
    const [showSuccessBox, setShowSuccessBox] = useState(false);
    const { feedId } = useParams();
    const [formData, setFormData] = useState({
        feed_name: "",
        feed_id: feedId,
        inclusion_type: "all",
        feed_filename: "latest.xml",
        del_method: "http",
        ftp_protocol: "ftp",
        is_upload_zip: false,
        feed_url: `${config.apiPath}vol/output-feeds/${sumo_current_account}/latest.xml`,
        ai_fields: [""],
        map_changes: {},
        mapped_fields: {}
    });
    const getFeedTags = async(feed_id) => {
        const response = await fetch(`${config.apiPath}output-feed/output-feed-ajax.php?type=feed_tags_with_field&feed_id=${feed_id}`, { method: 'GET',credentials: 'include' });
        const result = await response.json();
        if(result.status === 'error') {
            window.location.href = `/${config.appPath}`;
        }
        setFeedTags(result.tags);
        setProductFields(result.product_fields);
        
        const checkedFields = {};
        result.mapped_tags.forEach(tag => {
            checkedFields[`${tag}`] = true;
        });

        setFormData(prev => ({
        ...prev,
        mapped_fields: checkedFields
        }));
    }
    const handleCheckboxChange = (fieldname, value) => {
        setFormData((prev) => ({
            ...prev,
            mapped_fields: {
            ...prev.mapped_fields,
            [fieldname]: value
            }
        }));
    };
    const toggleSelectMap = (dataTag, type = "edit") => {
        if(type === "unset") {
            setShowFieldsMap((prev) => {
                // Create a shallow copy
                const newMap = { ...prev };
                delete newMap[dataTag]; // Unset the key
                return newMap;
            });
        }
        else {
            setShowFieldsMap((prev) => ({
                ...prev,
                [dataTag]: true, // or toggle: !prev[dataTag] if you want toggle behavior
            }));
        }
	};
    const updateAIFieldAtIndex = (index, value) => {
        const updatedFields = [...formData.ai_fields];
        updatedFields[index] = value;

        setFormData((prev) => ({
            ...prev,
            ai_fields: updatedFields,
        }));
    };
    const updateMapFieldAtIndex = (fieldname, value) => {
        setFormData((prev) => ({
            ...prev,
            map_changes: {
            ...prev.map_changes,
            [fieldname]: value
            }
        }));
    };

    const handleFieldChange = ({ name, value }) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        if(name === "feed_filename") {
            if(feedId !== 'add') {
                setFormData((prev) => ({
                ...prev,
                "feed_url": `${config.apiPath}vol/output-feeds/${sumo_current_account}/${feedId}/${value}`,
                }));
            }
            else {
                setFormData((prev) => ({
                ...prev,
                "feed_url": `${config.apiPath}vol/output-feeds/${sumo_current_account}/${value}`,
                }));
            }
        }
    };
    const handleRadioChange = (field_name,value) => {
        setFormData((prev) => ({
            ...prev,
            [field_name]: value,
        }));
    };
    const [activeTab, setActiveTab] = useState(0);
    const [loading, setLoading] = useState(false);
    const [breadcrumbLink, setBreadcrumbLink] = useState([]);
    const [addType, setAddType] = useState("Edit");

    const setFeedDetails = async(feedId) => {
        setLoading(true);
        const response = await fetch(`${config.apiPath}output-feed/output-feed-ajax.php?type=feed_details&feed_id=${feedId}`, { method: 'GET',credentials: 'include' });
        const feedRes = await response.json();
        if(feedRes.status === 'error') {
            window.location.href = `/${config.appPath}`;
        }
        const feedData = feedRes.data;
        if(!feedData.feed_name) {
            GotoPage("/output-feeds");
        }
        const checkedFields = {};
        feedData.mapped_tags.forEach(tag => {
            checkedFields[`${tag}`] = true;
        });
        setFeedTags(feedData.feed_tags);
        setFormData(prev => ({
        ...prev,
        feed_name: feedData.feed_name,
        inclusion_type: feedData.inclusion_type,
        feed_filename: feedData.feed_filename,
        feed_url: feedData.feed_url,
        del_method: feedData.delivery_method,
        is_upload_zip: feedData.is_upload_zip,
        ai_fields: feedData.ai_fields,
        ftp_protocol: feedData.ftp_protocol,
        ftp_hostname: feedData.ftp_hostname,
        ftp_username: feedData.ftp_username,
        ftp_password: feedData.ftp_password,
        ftp_port: feedData.ftp_port,
        mapped_fields: checkedFields
        }));

        cacheFTPProtocol    = feedData.ftp_protocol;
        cacheFTPHostname    = feedData.ftp_hostname;
        cacheFTPPort        = feedData.ftp_port;
        cacheFTPUsername    = feedData.ftp_username;
        cacheFTPPassword    = feedData.ftp_password;

        setIsDataLoaded(true);
        setLoading(false);
    }

    useEffect(() => {
        setErrors({});
        setBreadcrumbLink([
        { name: "Output Feeds", href: "/output-feeds" },
        {
            name: feedId === "add" ? "Add Output Feed" : "Edit Output Feed",
            href: "/",
            current: true,
        },
        ]);
        if(feedId === "add") {
            setAddType("Add");
            setIsDataLoaded(true);
        }
        else {
            setFeedDetails(feedId);
        }
        getFeedTags(feedId, setFeedDetails);
    }, [feedId]);

    const addNewInclusionCondition = () => {
        setFormData((prev) => ({...prev, ai_fields: [...prev.ai_fields, ""], }));
    };
    const removeInclusionCondition = (index) => {
        setFormData((prev) => ({...prev, ai_fields: prev.ai_fields.filter((_, i) => i !== index),}));
    };
    const navigate = useNavigate();
    const GotoPage = (pageName, message = "") => {
        if(pageName !== "" && pageName !== "#" && pageName !== "/") {
            setLoading(true); // Show loader
            setTimeout(() => {
            navigate(`${pageName}`, {state: { message: message }});
            }, 200); // Optional delay for UX smoothness
        }
    };
    const saveFeedSettings = async (e) => {
        e.preventDefault();
        if (!page_validate(3)) return;
        setLoading(true); // Show loader
        try {
            const res = await fetch(`${config.apiPath}output-feed/save-output-feed.php`, {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await res.json();
            if(result.status === 'error') {
                if(result.message === 'Invalid Login Data') {
                    window.location.href = `/${config.appPath}`;
                }
                else {
                    setErrorMsg(result.message);
                    setShowErrorBox(true);
                    setTimeout(() => {
                        setShowErrorBox(false);
                        setErrorMsg("");
                    }, 3000);
                }
            }
            else {
                console.log('Server response:', result);
                setTimeout(() => {
                    GotoPage("/output-feeds", result.message);
                }, 200);
            }
        } catch (error) {
            console.log("Error submitting form.", error);
            setLoading(false);
        }
    };
    const move_to_tab = (index) => {
        index = Number(index);
        if(activeTab >= index) {
            setActiveTab(index);
            console.log(`first ${activeTab}`);
        }
        else {
            if (!page_validate(index)) {
                return;
            }
            setActiveTab(index);
            console.log(`second ${activeTab}`);
        }
    }
    const isValidPort = (value) => {
        const portNumber = Number(value);
        return (
            Number.isInteger(portNumber) && 
            portNumber > 0 && 
            portNumber <= 65535
        );
    };
    const pushToFTP = async () => {
        setLoading(true); // Show loader
        if(feedId === "add") {
            setErrorMsg("Kindly save and generate the feed to push.");
            setShowErrorBox(true);
            setTimeout(() => {
                setShowErrorBox(false);
                setErrorMsg("");
            }, 3000);
        }
        else {
            if (!page_validate(3)) {
                setLoading(false);
                return;
            }
            else {
               // console.log(`${cacheFTPProtocol} -- ${formData.ftp_protocol}`);
                if(cacheFTPProtocol !== formData.ftp_protocol || cacheFTPHostname !== formData.ftp_hostname || cacheFTPPort !== formData.ftp_port || cacheFTPUsername !== formData.ftp_username || cacheFTPPassword !== formData.ftp_password) {
                    setErrorMsg("Changes made in configuration, kindly save and push.");
                    setShowErrorBox(true);
                    setTimeout(() => {
                        setShowErrorBox(false);
                        setErrorMsg("");
                    }, 3000);
                }
                else {
                    const ftpData = new FormData();
                    ftpData.append("ftp_protocol", formData.ftp_protocol);
                    ftpData.append("ftp_port", formData.ftp_port);
                    ftpData.append("ftp_hostname", formData.ftp_hostname);
                    ftpData.append("ftp_username", formData.ftp_username);
                    ftpData.append("ftp_password", formData.ftp_password);
                    ftpData.append("feed_id", feedId);
                    const res = await fetch(`${config.apiPath}output-feed/output-feed-ajax.php?type=push_to_ftp`, {
                        method: "POST",
                        credentials: 'include',
                        body: ftpData,
                    });
                    const result = await res.json();
                    if(result.status === 'error') {
                        setErrorMsg(result.message);
                        setShowErrorBox(true);
                        setTimeout(() => {
                            setShowErrorBox(false);
                            setErrorMsg("");
                        }, 3000);  
                    }
                    else {
                        setSuccessMsg(result.message);
                        setShowSuccessBox(true);
                        setTimeout(() => {
                            setShowSuccessBox(false);
                            setSuccessMsg("");
                        }, 3000);  
                    }
                }
            }
        }
        setLoading(false);
    }
    const testConnection = async () => {
        if (!page_validate(3)) {
            return;   
        }
        else {
            setLoading(true); // Show loader
            const ftpData = new FormData();
            ftpData.append("ftp_protocol", formData.ftp_protocol);
            ftpData.append("ftp_port", formData.ftp_port);
            ftpData.append("ftp_hostname", formData.ftp_hostname);
            ftpData.append("ftp_username", formData.ftp_username);
            ftpData.append("ftp_password", formData.ftp_password);
            const res = await fetch(`${config.apiPath}output-feed/output-feed-ajax.php?type=test_connection`, {
                method: "POST",
                credentials: 'include',
                body: ftpData,
            });
            const result = await res.json();
            if(result.status === 'error') {
                setErrorMsg(result.message);
                setShowErrorBox(true);
                setTimeout(() => {
                    setShowErrorBox(false);
                    setErrorMsg("");
                }, 3000);  
            }
            else {
                setSuccessMsg(result.message);
                setShowSuccessBox(true);
                setTimeout(() => {
                    setShowSuccessBox(false);
                    setSuccessMsg("");
                }, 3000);  
            }
            setLoading(false);
        }
    };
    const page_validate = (tab = 3) => {
        const newErrors = {};
        setErrors({});
        //Product Selection Validation
        if(tab >= 1) {
            if (!formData.feed_name) {
                newErrors.feed_name = 'Feed name is required';
                setErrors(newErrors);
                return 0;
            }
            if(formData.inclusion_type === "filter_based") {
                newErrors.ai_fields = [];
                let errorExists = false;
                let selectedFields = [];
                formData.ai_fields.map((value, index) => {
                    if(value === "") {
                        newErrors.ai_fields[index] = 'Kindly select any field';
                        errorExists = true;
                        setErrors(newErrors);
                    }
                    else {
                        if (selectedFields.includes(value)) {
                            newErrors.ai_fields[index] = 'Same field already selected';
                            errorExists = true;
                            setErrors(newErrors);
                        }
                        else {
                            selectedFields.push(value);
                        }
                    }
                })
                if(errorExists === false) {
                    delete newErrors.ai_fields;
                }
                else {
                    return 0;
                }
            }
        }
        if(tab >= 2) {
            const trueCount = Object.values(formData.mapped_fields).filter(Boolean).length;
           if(trueCount <= 1) {
                setActiveTab(1);
                newErrors.mapped_fields = 'Map atleast one field to proceed';
                setErrors(newErrors);
                return 0;
            }
        }
        if(tab === 3) {
            let errorConfig = false;
            if (!formData.feed_filename.endsWith(".xml")) {
                newErrors.feed_filename = 'Feed filename should be end with .xml';
                setErrors(newErrors);
                errorConfig = true;
            }
            if (!formData.feed_filename) {
                newErrors.feed_filename = 'Feed filename is required';
                setErrors(newErrors);
                errorConfig = true;
            }
            if(formData.del_method === "ftp") {
                if(!formData.ftp_hostname) {
                    newErrors.ftp_hostname = 'FTP hostname is required';
                    setErrors(newErrors);
                    errorConfig = true;
                }
                if(!isValidPort(formData.ftp_port)) {
                    newErrors.ftp_port = 'Enter valid FTP port';
                    setErrors(newErrors);
                    errorConfig = true;
                }
                if(!formData.ftp_port) {
                    newErrors.ftp_port = 'FTP port is required';
                    setErrors(newErrors);
                    errorConfig = true;
                }
                if(!formData.ftp_username) {
                    newErrors.ftp_username = 'FTP username is required';
                    setErrors(newErrors);
                    errorConfig = true;
                }
                if(!formData.ftp_password) {
                    newErrors.ftp_password = 'FTP password is required';
                    setErrors(newErrors);
                    errorConfig = true;
                }
            }
            if(errorConfig === true) {
                return 0;
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const tabs = [
        { name: 'Products Selection', href: '#', icon: FunnelIcon, current: true },
        { name: 'Field set-up', href: '#', icon: DocumentTextIcon, current: false },
        { name: 'Hosting', href: '#', icon: ArrowsRightLeftIcon, current: false },
    ]
    return (
    <Fragment>
      <SidebarLayoutNew selected_menu="output-feeds">
        <SuccessNotification showSuccessBox={showSuccessBox} successMsg={successMsg} setShowSuccessBox={setShowSuccessBox} />
        <ErrorNotification showErrorBox={showErrorBox} errorMsg={errorMsg} setShowErrorBox={setShowErrorBox} />
        <BreadcrumbsNew pages={breadcrumbLink} />
        <div className="flex w-full items-center gap-3 rounded-lg !pl-0 px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
        {
            feedId === "add" ? <DocumentPlusIcon className="!size-8"/> : <PencilSquareIcon className="!size-8"/>
        }
            <Heading>{addType} Feed Settings</Heading>
        </div>
        <PageInfo info={page_info} />

        <form onSubmit={saveFeedSettings}>
        <div className="space-y-12 sm:space-y-16">
            <div>
                <div className="space-y-8 border-b border-gray-900/10 pb-12 sm:space-y-0 sm:border-t sm:pb-0">
                    <div className="sm:grid sm:grid-cols-6 sm:gap-4 sm:py-4">
                        <label htmlFor="feed_name" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5 dark:text-white">Feed Name</label>
                        <div className="mt-2 sm:col-span-4 sm:mt-0">
                            <div className={`flex rounded-md bg-white pl-3 outline-1 -outline-offset-1 ${errors.feed_name
                          ? "outline-red-300" : "outline-gray-300"} focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600 sm:max-w-xs`}>
                                <input id="feed_name" name="feed_name" value={formData.feed_name} onChange={(value) => {
  handleFieldChange({ name: 'feed_name', value: value.target.value }); }} type="text" className="block min-w-0 grow py-1.5 pr-3 pl-1 text-base text-gray-900 focus:outline-none sm:text-sm/6"/>
                            </div>
                            {errors.feed_name && <p className="text-red-500 text-sm mt-1">{errors.feed_name}</p>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div className="grid grid-cols-1 sm:hidden">
                {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
                <select aria-label="Select a tab" className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pr-8 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600" value={activeTab} onChange={(value) => move_to_tab(value.target.value)}>
                {tabs.map((tab, index) => (
                    <option key={tab.name} value={index}>{tab.name}</option>
                ))}
                </select>
                <ChevronDownIcon aria-hidden="true" className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500" />
            </div>
            <div className="hidden sm:block">
                <div className="border-b border-gray-200">
                    <nav aria-label="Tabs" className="-mb-px flex space-x-8">
                        {tabs.map((tab, index) => (
                        <a key={tab.name} onClick={() => move_to_tab(index)} aria-current={activeTab === index ? 'page' : undefined} className={classNames(
                            activeTab === index ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'group inline-flex items-center border-b-2 px-1 py-4 text-sm font-medium cursor-pointer', activeTab === index ? "border-indigo-500 text-indigo-600" : "text-gray-500 hover:text-blue-500" )}>
                            <tab.icon aria-hidden="true" className={classNames(activeTab === index ? 'text-indigo-500' : 'text-gray-400 group-hover:text-gray-500','mr-2 -ml-0.5 size-5',)}
                            />
                            <span>{tab.name}</span>
                        </a>
                        ))}
                    </nav>
                </div>
            </div>
        </div>
        {/* Tab content */}
            {/* All tab contents rendered, only active is visible */}
        <div className="mt-4 text-gray-700">
            
            <div key="0" className={`${activeTab === 0 ? "block" : "hidden"}`}>
                {isDataLoaded && (<ProductsSelection feed-id = {feedId} handleFieldChange={handleFieldChange} AddInclusionFields={addNewInclusionCondition} removeInclusionCondition={removeInclusionCondition} updateAIFieldAtIndex={updateAIFieldAtIndex} errors={errors} formData={formData} />
                )}
                    <div className="mt-4 flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
                    <Button className="-my-0.5 inline-flex justify-end ml-auto" onClick={() => move_to_tab(1)}>Next<ArrowRightIcon aria-hidden="true" className="-ml-0.5 size-5" /></Button>
                </div>

            </div>
            <div key="1" className={`${activeTab === 1 ? "block" : "hidden"}`}>
                {isDataLoaded && (
                    <FieldSetup feed-id = "" handleCheckboxChange={handleCheckboxChange} feedTags={feedTags} productFields={productFields} showFieldsMap={showFieldsMap} toggleSelectMap={toggleSelectMap} updateMapFieldAtIndex={updateMapFieldAtIndex} formData={formData} errors={errors}/>
                )}
                <div className="mt-4 flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
                    <Button outline className="inline-flex justify-start" onClick={() => setActiveTab(0)}><ArrowLeftIcon aria-hidden="true" className="-ml-0.5 size-5" />Back</Button>
                    <Button className="-my-0.5 inline-flex justify-end ml-auto" onClick={() => move_to_tab(2)}>Next<ArrowRightIcon aria-hidden="true" className="-ml-0.5 size-5" /></Button>
                </div>
            </div>
            <div key="2" className={`${activeTab === 2 ? "block" : "hidden"}`}>
                {isDataLoaded && (
                    <FeedHosting feed-id = {feedId} handleFieldChange={handleFieldChange} handleRadioChange={handleRadioChange} errors={errors} formData={formData} testConnection={testConnection} pushToFTP={pushToFTP} />
                )}
                <div className="mt-4 flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
                    <Button outline className="inline-flex justify-start" onClick={() => setActiveTab(1)}><ArrowLeftIcon aria-hidden="true" className="-ml-0.5 size-5" />Back</Button>
                    <Button type="submit" className="-my-0.5 inline-flex justify-end ml-auto">Save Feed</Button>
                </div>
            </div>
        </div>
        </form>
        {loading && (
            <Loader />
        )}
       </SidebarLayoutNew>
    </Fragment>
  );
}